import { Component, OnInit, OnDestroy } from '@angular/core';
import { LivestreamService } from '../../Services/livestream.service'
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-livestream',
  templateUrl: './livestream.component.html',
  styleUrls: ['./livestream.component.scss']
})
export class LivestreamComponent implements OnInit, OnDestroy
{
  subscription = new Subscription();
  constructor(private livestreamService: LivestreamService, private router: Router, private appComponent: AppComponent, private sanitizer: DomSanitizer) { }
  Livestreamcontent: any[];
  LiveStreamdata: any = [];
  url: any;
  index: any = 0;
  isLoading: boolean = false;

  ngOnInit()
  {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
    this.getLivestreamData();
  }
  getLivestreamData() {
    this.isLoading = true;
    this.subscription = this.livestreamService.GetLivestream().subscribe(res => {
      this.isLoading = false;
      if (res != null)
      {
        if (res.Response.Data.LivestreamUrls!=null && res.Response.Data.LivestreamUrls.length > 0) {
          this.Livestreamcontent = res.Response.Data.WebpageDetails.Content;

          res.Response.Data.LivestreamUrls.forEach(childObj => {
            this.LiveStreamdata.push(childObj)
          })
        }
        else
        {
          this.Livestreamcontent = null;
        }
      }
    }, err => {
      console.log('err in faculty component', err);
    });
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
